import { useMemo } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { EventsList } from '@/widgets/events-list'
import { useEvents } from '@/entities/event'
import { isEventActive } from '@/entities/event/lib/helpers'
import { AppShell } from '@/shared/ui/app-shell'
import { BottomNav } from '@/widgets/bottom-nav'
import { MainHeader, PageTitle } from '@/shared/ui'

export const Route = createFileRoute('/events')({
  component: EventsPage,
})

function EventsPage() {
  const { data, isLoading } = useEvents({
    page: 1,
    limit: 50,
  })

  const rawEvents = data?.data || []
  
  // Фильтруем только активные события (scheduled, ongoing)
  // Исключаем черновики, отменённые и завершённые
  const events = useMemo(() => {
    return rawEvents.filter(isEventActive)
  }, [rawEvents])
  
  // Подзаголовок
  const subtitle = isLoading 
    ? undefined
    : events.length === 0 
      ? 'Скоро появятся новые события'
      : `${events.length} ${events.length === 1 ? 'событие' : events.length < 5 ? 'события' : 'событий'}`

  return (
    <AppShell showBottomNav>
      <div className="flex-1 overflow-y-auto bg-paper dark:bg-[#0F1113] pt-safe">
        {/* Контейнер с адаптивными отступами — как на главной */}
        <div className="min-h-full content-container py-6">
          {/* Унифицированный хедер */}
          <MainHeader />
          
          {/* Заголовок страницы */}
          <PageTitle 
            title="События" 
            subtitle={subtitle}
            className="mt-6"
          />

          {/* Список событий */}
          <div className="mt-6">
            <EventsList
              events={events}
              loading={isLoading}
              emptyMessage="Скоро появятся новые события"
            />
          </div>
          
          {/* Отступ снизу для Bottom Nav */}
          <div className="h-20" />
        </div>
      </div>
      <BottomNav />
    </AppShell>
  )
}
